import {
  compose,
  withReducer,
  withHandlers,
  withPropsOnChange,
  lifecycle,
  withProps
} from 'recompose';
import { connect } from 'react-redux';

import logger from 'services/logger';
import { pushQueryParams } from 'services/history';
import pageLayout from 'HOC/pageLayout';
import withQueryParams from 'HOC/withQueryParams';
import Articles from './Articles';
import ApiService from 'services/api';
import PagesModule from 'modules/pages';


export default compose(
  pageLayout(),
  withQueryParams,
  withProps(props => {
    const categoryId =
      props.queryParams.category === 'all' ? '' : props.queryParams.category;
    const page = props.queryParams.page || 1;
    return {
      categoryId,
      page,
    };
  }),
  withReducer(
    'articles',
    'dispatch',
    (state, action) => {
      const { type, payload } = action;

      switch (type) {
        case 'GET_ARTICLES_REQUEST':
          return { ...state, isLoading: true };
        case 'GET_ARTICLES_FAILURE':
          return { ...state, isLoading: false };
        case 'GET_ARTICLES_SUCCESS':
          return {
            ...state,
            isLoading: false,
            list: payload.list,
            pagination: {
              ...state.pagination,
              total: payload.total,
            }
          };
        case 'CHANGE_PAGINATION':
          return {
            ...state,
            pagination: {
              ...state.pagination,
              page: payload.page,
            }
          };
        case 'GET_CATEGORIES':
          return { ...state, categories: payload.list };
        default:
          return state;
      }
    },
    props => {
      const page = parseInt(props.queryParams.page) || 1;
      const PER_PAGE = 16;

      return {
        isLoading: true,
        list: [],
        pagination: {
          page,
          items: PER_PAGE,
          total: 0
        },
        categories: []
      };
    }
  ),
  withHandlers({
    getArticles: ({ dispatch, articles, categoryId, page }) => async () => {
      dispatch({ type: 'GET_ARTICLES_REQUEST' });
      dispatch({ type: 'CHANGE_PAGINATION', payload: { page: parseInt(page) } });
      try {
        const { total, articles: list } = await ApiService.getArticles({
          // page: articles.pagination.page,
          // items: articles.pagination.items,
          page: page,
          categoryId
        });
        dispatch({
          type: 'GET_ARTICLES_SUCCESS',
          payload: { list, total }
        });
      } catch (error) {
        dispatch({ type: 'GET_ARTICLES_FAILURE' });
        logger(error);
      }
    }
  }),
  withHandlers({
    handlePaginationChange: ({ dispatch, queryParams }) => page => {
      pushQueryParams({ page });
      dispatch({ type: 'CHANGE_PAGINATION', payload: { page } });
    }
  }),
  withPropsOnChange(
    (props, nextProps) => {
      return (
        props.articles.pagination.page !== nextProps.articles.pagination.page ||
        props.queryParams.category !== nextProps.queryParams.category
      );
    },
    props => {
      props.getArticles();
    }
  ),
  connect(state => {
    return {
      categories: state.articleCategories.list,
      dataPage: state.pages.articles,
    };
  },
    {
      getArticlesCommonData: PagesModule.fetch,
    }),
  lifecycle({
    componentDidMount() {
      const { getArticlesCommonData } = this.props;
      getArticlesCommonData('articles');
    }
  }),
)(Articles);
